/* =====================================================
   MONEY FORMATTER (DAWN / EXTERNAL JS SAFE)
===================================================== */

document.addEventListener('click', function (e) {
    const btn = e.target.closest('.copy-offer-btn');

    if (!btn) return;

    const code = btn.getAttribute('data-copy');

    if (!code) return;

    navigator.clipboard.writeText(code).then(() => {

        btn.classList.add('is-copied');

        btn.disabled = true;

        setTimeout(() => {

            btn.classList.remove('is-copied');

            btn.disabled = false;

        }, 1500);
    });
});

function formatMoney(cents) {

    if (cents == null) return '';

    const amount = Number(cents) / 100;

    return amount.toLocaleString('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 2
    });
}

/* =====================================================
   LOAD QUICK VIEW PRODUCT
===================================================== */

async function loadQuickViewProduct(handle, content) {

    try {

        const res = await fetch(
            `/products/${handle}?view=quick-view`,
            {
                credentials: 'same-origin',
                redirect: 'follow'
            }
        );

        const html = await res.text();

        if (!html || html.trim().length === 0) {
            throw new Error('Empty HTML response');
        }

        content.innerHTML = html;

        content.dispatchEvent(
            new CustomEvent('quickview:loaded', {
                bubbles: true
            })
        );

        initQuickView(content);

    } catch (err) {

        console.error('Quick View load failed:', err);

        content.innerHTML =
            '<p style="color:red">Failed to load product</p>';
    }
}

/* =====================================================
   QUICK VIEW / QUICK ADD INITIALIZER
===================================================== */

function initQuickView(scope) {

    const productJSON =
        scope.querySelector('[data-qv-product-json]');

    if (!productJSON) return;

    const product =
        JSON.parse(productJSON.textContent);

    const variantInput =
        scope.querySelector('[data-qv-variant-id]');

    const priceEl =
        scope.querySelector('[data-qv-price]');

    const optionGroups =
        scope.querySelectorAll('[data-option-index]');

    const submitBtn =
        scope.querySelector('.qv-atc, .qac-atc');

    if (!variantInput || !optionGroups.length) return;

    /* =====================================================
       SET DEFAULT AVAILABLE OPTIONS
    ===================================================== */

    const firstAvailableVariant = product.variants.find(
        variant => variant.available
    );

    if (firstAvailableVariant) {

        optionGroups.forEach((group, index) => {

            const value =
                firstAvailableVariant.options[index];

            const btn = [
                ...group.querySelectorAll('.qv-option')
            ].find(
                optionBtn =>
                    optionBtn.dataset.value === value
            );

            if (btn) {
                btn.classList.add('is-active');
            }
        });
    }

    /* =====================================================
       RESOLVE VARIANT
    ===================================================== */

    function resolveVariant() {

        const selectedValues = [...optionGroups].map(group =>
            group.querySelector('.is-active')?.dataset.value
        );

        const variant = product.variants.find(v =>
            v.options.every(
                (opt, i) => opt === selectedValues[i]
            )
        );

        if (!variant) {

            if (submitBtn) {

                submitBtn.disabled = true;

                submitBtn.textContent = 'Unavailable';
            }

            return;
        }

        /* UPDATE VARIANT INPUT */

        variantInput.value = variant.id;

        /* UPDATE PRICE */

        if (priceEl) {

            priceEl.textContent =
                formatMoney(variant.price)
                    .replace(/\.00$/, '');
        }

        /* UPDATE COMPARE PRICE */

        const compareEl = scope.querySelector(
            '.qv-compare, .qac-compare'
        );

        const discountEl = scope.querySelector(
            '.qv-discount, .qac-discount'
        );

        if (compareEl && discountEl) {

            if (
                variant.compare_at_price &&
                variant.compare_at_price > variant.price
            ) {

                compareEl.textContent =
                    formatMoney(variant.compare_at_price)
                        .replace(/\.00$/, '');

                compareEl.style.display = 'block';

                discountEl.style.display = 'block';

                const discount = Math.round(
                    (
                        (variant.compare_at_price - variant.price)
                        / variant.compare_at_price
                    ) * 100
                );

                discountEl.textContent =
                    `${discount}% OFF`;

            } else {

                compareEl.style.display = 'none';

                discountEl.style.display = 'none';
            }
        }

        /* UPDATE AVAILABILITY */

        if (submitBtn) {

            if (variant.available) {

                submitBtn.disabled = false;

                submitBtn.textContent = 'Add to Cart';

            } else {

                submitBtn.disabled = true;

                submitBtn.textContent = 'Sold Out';
            }
        }

        /* UPDATE IMAGE */

        const image =
            scope.querySelector('[data-qac-image]');

        if (
            image &&
            variant.featured_image?.src
        ) {

            image.src =
                variant.featured_image.src + '&width=600';
        }

        /* UPDATE MEASUREMENTS */

        updateMeasurements(scope, variant.id);

        return variant;
    }

    /* =====================================================
       UPDATE OPTION AVAILABILITY
    ===================================================== */

    function updateOptionAvailability() {

        const selectedValues = [...optionGroups].map(group =>
            group.querySelector('.is-active')?.dataset.value
        );

        optionGroups.forEach((group, groupIndex) => {

            const buttons =
                group.querySelectorAll('.qv-option');

            buttons.forEach(button => {

                const testValues = [...selectedValues];

                testValues[groupIndex] =
                    button.dataset.value;

                const matchingVariant =
                    product.variants.find(v =>
                        v.options.every(
                            (opt, i) =>
                                opt === testValues[i]
                        )
                    );

                const isAvailable =
                    matchingVariant &&
                    matchingVariant.available;

                button.classList.toggle(
                    'is-unavailable',
                    !isAvailable
                );

                button.disabled = !isAvailable;
            });
        });
    }

    /* =====================================================
       OPTION CLICK
    ===================================================== */

    optionGroups.forEach(group => {

        group.addEventListener('click', e => {

            const btn =
                e.target.closest('.qv-option');

            if (!btn) return;

            if (
                btn.disabled ||
                btn.classList.contains(
                    'is-unavailable'
                )
            ) {
                return;
            }

            group.querySelectorAll('.qv-option')
                .forEach(b =>
                    b.classList.remove('is-active')
                );

            btn.classList.add('is-active');

            resolveVariant();

            updateOptionAvailability();
        });
    });

    /* =====================================================
       INITIAL LOAD
    ===================================================== */

    resolveVariant();

    updateOptionAvailability();
}

/* =====================================================
   VARIANT MEASUREMENTS
===================================================== */

function updateMeasurements(scope, variantId) {

    const blocks = scope.querySelectorAll(
        '[data-qv-measurements] .variant-measurements'
    );

    blocks.forEach(el => {

        el.style.display =
            String(el.dataset.variantId)
                === String(variantId)
                ? 'block'
                : 'none';
    });
}

/* =====================================================
   OPEN / CLOSE QUICK VIEW
===================================================== */

document.addEventListener('click', (e) => {

    const drawer =
        document.getElementById('qvDrawer');

    if (!drawer) return;

    /* OPEN */

    const trigger =
        e.target.closest('[data-quick-view]');

    if (trigger) {

        e.preventDefault();

        const handle = trigger.dataset.handle;

        if (!handle) return;

        drawer.classList.add('is-open');

        document.body.style.overflow = 'hidden';

        const content =
            drawer.querySelector('.qv-content');

        content.innerHTML = '';

        loadQuickViewProduct(handle, content);

        return;
    }

    /* CLOSE */

    if (
        e.target.closest('[data-qv-close]') ||
        e.target.classList.contains('qv-overlay')
    ) {

        drawer.classList.remove('is-open');

        document.body.style.overflow = '';

        drawer.querySelector('.qv-content').innerHTML = '';
    }
});

/* =====================================================
   AJAX ADD TO CART
===================================================== */

document.addEventListener('submit', async (e) => {

    const form = e.target.closest(
        '#qvDrawer [data-ajax-cart], #qacDrawer [data-ajax-cart]'
    );

    if (!form) return;

    e.preventDefault();

    const submitBtn =
        form.querySelector('[type="submit"]');

    submitBtn?.classList.add('loading');

    try {

        const res = await fetch('/cart/add.js', {
            method: 'POST',
            body: new FormData(form),
            headers: {
                Accept: 'application/json'
            }
        });

        if (!res.ok) {
            throw new Error('Cart add failed');
        }

        document.dispatchEvent(
            new CustomEvent('cart:refresh')
        );

        /* CLOSE QUICK ADD */

        const qacDrawer =
            document.getElementById('qacDrawer');

        if (qacDrawer) {

            qacDrawer.classList.remove('is-open');

            const content =
                qacDrawer.querySelector('.qac-content');

            if (content) {
                content.innerHTML = '';
            }
        }

        /* CLOSE QUICK VIEW */

        const qvDrawer =
            document.getElementById('qvDrawer');

        if (qvDrawer) {

            qvDrawer.classList.remove('is-open');

            const content =
                qvDrawer.querySelector('.qv-content');

            if (content) {
                content.innerHTML = '';
            }
        }

        document.body.style.overflow = '';

    } catch (err) {

        console.error(
            'Quick View ATC failed:',
            err
        );

    } finally {

        submitBtn?.classList.remove('loading');
    }
});

/* =====================================================
   BUY NOW
===================================================== */

document.addEventListener('click', async (e) => {

    const btn =
        e.target.closest('[data-qv-buy-now]');

    if (!btn) return;

    const form =
        btn.closest('[data-qv-form]');

    if (!form) return;

    const variantId =
        form.querySelector(
            '[data-qv-variant-id]'
        )?.value;

    if (!variantId) return;

    await fetch('/cart/clear.js', {
        method: 'POST'
    });

    await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            id: variantId,
            quantity: 1
        })
    });

    window.location.href = '/checkout';
});

/* =====================================================
   LOAD QUICK ADD CART
===================================================== */

async function loadQuickAddCart(handle, content) {

    try {

        const res = await fetch(
            `/products/${handle}?view=quick-add`,
            {
                credentials: 'same-origin',
                redirect: 'follow'
            }
        );

        const html = await res.text();

        content.innerHTML = html;

        initQuickView(content);

        initQuickAddQty(content);

    } catch (err) {

        console.error(
            'Quick Add Cart failed:',
            err
        );
    }
}

/* =====================================================
   QUICK ADD QTY
===================================================== */

function initQuickAddQty(scope) {

    const qtyInput =
        scope.querySelector('[data-qac-qty]');

    if (!qtyInput) return;

    scope.addEventListener('click', (e) => {

        const plus =
            e.target.closest('[data-qac-plus]');

        const minus =
            e.target.closest('[data-qac-minus]');

        if (plus) {

            qtyInput.value =
                Number(qtyInput.value) + 1;
        }

        if (minus) {

            const next =
                Number(qtyInput.value) - 1;

            qtyInput.value =
                next < 1 ? 1 : next;
        }
    });
}

/* =====================================================
   OPEN / CLOSE QUICK ADD
===================================================== */

document.addEventListener('click', async (e) => {

    const drawer =
        document.getElementById('qacDrawer');

    if (!drawer) return;

    /* OPEN */

    const trigger =
        e.target.closest('[data-quick-add-cart]');

    if (trigger) {

        e.preventDefault();

        const handle =
            trigger.dataset.handle;

        if (!handle) return;

        drawer.classList.add('is-open');

        document.body.style.overflow = 'hidden';

        const content =
            drawer.querySelector('.qac-content');

        content.innerHTML = '';

        await loadQuickAddCart(handle, content);

        return;
    }

    /* CLOSE */

    if (
        e.target.closest('[data-qac-close]') ||
        e.target.classList.contains('qac-overlay')
    ) {

        drawer.classList.remove('is-open');

        document.body.style.overflow = '';

        drawer.querySelector('.qac-content').innerHTML = '';
    }
});